@if (product().image; as image) {
  <img [src]="image" (click)="onView()"
    class="tw-h-full tw-shrink-0 tw-rounded-1 tw-object-cover tw-cursor-pointer"
    [ngClass]="fullBleedImage() ? 'tw-w-24 tw-bg-gray-225' : 'tw-w-78'" alt="" />
} @else {
  <div (click)="onView()"
    class="tw-h-full tw-shrink-0 tw-rounded-1 tw-cursor-pointer"
    [ngClass]="fullBleedImage() ? 'tw-w-24 tw-bg-gray-225' : 'tw-w-78 tw-bg-gray-100'"></div>
}
<div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between tw-min-w-0 tw-overflow-hidden">
  <div class="tw-flex-1 tw-min-h-0">
    <ng-content select="[card-tag]"></ng-content>
    <h1 (click)="onView()" class="tw-font-lexend tw-text-gray-800 tw-text-200 tw-pr-1 tw-line-clamp-2 tw-cursor-pointer">{{ product().title }}</h1>
  </div>
  <div class="tw-flex tw-justify-between tw-items-end tw-gap-2 tw-mt-2 tw-min-w-0 tw-font-lexend">
    <div class="tw-flex-1 tw-min-w-0">
      <span class="tw-text-400 tw-font-bold tw-block tw-leading-[16px] tw-text-orange-500">₹{{ product().price }}</span>
      <del class="tw-text-gray-400 tw-block tw-text-200">₹{{ product().mrp }}</del>
    </div>
    @if (quantity() > 0) {
      <div class="tw-flex tw-items-center tw-gap-1 tw-bg-teal-600 tw-rounded-3 tw-px-2 tw-py-1 tw-flex-shrink-0 tw-max-w-[80px]">
        <div (click)="onRemove()" role="button" tabindex="0"
          class="tw-text-white tw-font-bold tw-text-300 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-leading-none tw-flex-shrink-0 tw-cursor-pointer">-</div>
        <span class="tw-text-white tw-font-bold tw-text-300 tw-min-w-[16px] tw-text-center tw-flex-shrink-0">{{ quantity() }}</span>
        <div (click)="onAdd()" role="button" tabindex="0"
          class="tw-text-white tw-font-bold tw-text-300 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-leading-none tw-flex-shrink-0 tw-cursor-pointer">+</div>
      </div>
    } @else {
      <div (click)="onAdd()" role="button" tabindex="0"
        class="tw-bg-teal-600 tw-w-20 tw-h-8 tw-text-white tw-text-200 tw-font-bold tw-flex tw-justify-center tw-items-center tw-rounded-2 tw-flex-shrink-0 tw-max-w-[80px] tw-cursor-pointer"
        i18n="@@add">Add</div>
    }
  </div>
</div>
